<template>
  <div class="flex flex-col md:flex-row gap-4 flex-wrap">
    <paid :data="paid" />
    <pending :data="pending" />
    <canceled :data="canceled" />
    <failed :data="failed" />
    <others :data="others" />
  </div>
</template>

<script>
import TransactionStatusManager from './transaction-status.manager'

export default {
  name: 'TransactionStatus',

  components: {
    Paid: () => import('./Paid.vue'),
    Pending: () => import('./Pending.vue'),
    Canceled: () => import('./Canceled.vue'),
    Failed: () => import('./Failed.vue'),
    Others: () => import('./Others.vue')
  },

  props: {
    data: Array,
    total: Number
  },

  computed: {
    instance () {
      return new TransactionStatusManager(this.data, this.total)
    },
    paid () {
      return this.instance.paid()
    },
    pending () {
      return this.instance.pending()
    },
    canceled () {
      return this.instance.canceled()
    },
    failed () {
      return this.instance.failed()
    },
    others () {
      return this.instance.others()
    }
  }
}
</script>
